module.exports = "/_next/static/images/Cover@2x-46a7fe3f54a35ea33713a3bae1873a49.webp";